<template>
  <div class="data-table-empty-state">
    <svg
      width="64"
      height="41"
      viewBox="0 0 64 41"
      xmlns="http://www.w3.org/2000/svg"
      class="data-table-empty-state__svg"
    >
      <title>{{ title || "No data" }}</title>
      <g transform="translate(0 1)" fill="none" fill-rule="evenodd">
        <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
        <g fill-rule="nonzero" stroke="#d9d9d9">
          <path
            d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
          ></path>
          <path
            d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
            fill="#fafafa"
          ></path>
        </g>
      </g>
    </svg>
    <h3 v-if="title" class="data-table-empty-state__title">{{ title }}</h3>
    <p v-if="displayMessage" class="data-table-empty-state__description">{{ displayMessage }}</p>
    <div v-if="showActionButton || $slots.action || action" class="data-table-empty-state__action">
      <slot name="action">
        <button
          v-if="showActionButton && actionLabel"
          class="data-table-empty-state__action-button"
          @click="handleAction"
        >
          {{ actionLabel }}
        </button>
        <component :is="action" v-else-if="action" />
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

interface Props {
  title?: string;
  description?: string;
  message?: string;
  action?: any;
  showAction?: boolean;
  actionLabel?: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: "No data found",
  description: "There are no records to display at this time.",
});

const emit = defineEmits<{
  action: [];
}>();

const displayMessage = computed(() => {
  return props.description || props.message || "There are no records to display at this time.";
});

const showActionButton = computed(() => {
  return props.showAction && props.actionLabel;
});

const handleAction = () => {
  emit("action");
};
</script>

<style scoped>
.data-table-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 16px;
}

.data-table-empty-state__svg {
  margin-bottom: 16px;
}

.data-table-empty-state__title {
  font-size: 14px;
  color: #6b7280;
  text-align: center;
  max-width: 384px;
  margin: 0 0 4px 0;
}

.data-table-empty-state__description {
  font-size: 12px;
  color: #6b7280;
  text-align: center;
  max-width: 384px;
  margin: 0 0 16px 0;
}

.data-table-empty-state__action {
  margin-top: 4px;
}
</style>
